/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.8.2.0 (NJsonSchema v10.2.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class QualityClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * Get audit reports' list for Customer (Auth roles: Customer; policy: Customer_Quality)
   * @param query (optional) Serialization of QueryInfo data Type
   * @return Return Audit reports list for Customer
   */
  myList(
    from: string,
    to: string,
    query: string | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AuditReportListItemDTOQueryResult> {
    let url_ = this.baseUrl + '/api/quality/my-list/{from}/{to}?';
    if (from === undefined || from === null) throw new Error("The parameter 'from' must be defined.");
    url_ = url_.replace('{from}', encodeURIComponent('' + from));
    if (to === undefined || to === null) throw new Error("The parameter 'to' must be defined.");
    url_ = url_.replace('{to}', encodeURIComponent('' + to));
    if (query === null) throw new Error("The parameter 'query' cannot be null.");
    else if (query !== undefined) url_ += 'query=' + encodeURIComponent('' + query) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processMyList(_response);
      });
  }

  protected processMyList(response: AxiosResponse): Promise<AuditReportListItemDTOQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AuditReportListItemDTOQueryResult.fromJS(resultData200);
      return result200;
    } else if (status === 204) {
      const _responseText = response.data;
      return throwException('Customer not active', status, _responseText, _headers);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('From-To dates are note in a correct format', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('Customer not found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<AuditReportListItemDTOQueryResult>(<any>null);
  }

  /**
   * Download a audit report document (Auth roles: Administrator,Customer,Pulinet; policy: Customer_Quality)
   * @return Downloaded document
   */
  downloadReport(reportid: number, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/quality/download-report/{reportid}';
    if (reportid === undefined || reportid === null) throw new Error("The parameter 'reportid' must be defined.");
    url_ = url_.replace('{reportid}', encodeURIComponent('' + reportid));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      responseType: 'blob',
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/octet-stream',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadReport(_response);
      });
  }

  protected processDownloadReport(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers['content-disposition'] : undefined;
      const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
      const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('File Not Found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(<any>null);
  }

  /**
   * Get audit reports' list (Auth roles: Administrator,Pulinet)
   * @param query (optional) Serialization of QueryInfo data Type
   * @return Return reports list filtered by customer
   */
  list(
    customercode: string,
    query: string | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AuditReportListItemDTOQueryResult> {
    let url_ = this.baseUrl + '/api/quality/list/{customercode}?';
    if (customercode === undefined || customercode === null)
      throw new Error("The parameter 'customercode' must be defined.");
    url_ = url_.replace('{customercode}', encodeURIComponent('' + customercode));
    if (query === null) throw new Error("The parameter 'query' cannot be null.");
    else if (query !== undefined) url_ += 'query=' + encodeURIComponent('' + query) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processList(_response);
      });
  }

  protected processList(response: AxiosResponse): Promise<AuditReportListItemDTOQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AuditReportListItemDTOQueryResult.fromJS(resultData200);
      return result200;
    } else if (status === 204) {
      const _responseText = response.data;
      return throwException('Customer not active', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('Customer not found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<AuditReportListItemDTOQueryResult>(<any>null);
  }

  /**
   * Get quality control list for Customer (Auth roles: Customer; policy: Customer_QualityControls)
   * @return Return quality control list for Customer
   */
  myControlList(cancelToken?: CancelToken | undefined): Promise<QualityControlListItemDTO[]> {
    let url_ = this.baseUrl + '/api/quality/my-control-list';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processMyControlList(_response);
      });
  }

  protected processMyControlList(response: AxiosResponse): Promise<QualityControlListItemDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(QualityControlListItemDTO.fromJS(item));
      }
      return result200;
    } else if (status === 204) {
      const _responseText = response.data;
      return throwException('Customer not active', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('Customer not found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<QualityControlListItemDTO[]>(<any>null);
  }

  /**
   * Get quality control calendar for Customer (Auth roles: Customer; policy: Customer_QualityControls)
   * @param year (optional)
   * @param sitecode (optional)
   * @return Return quality control calendar for Customer
   */
  myControlCalendar(
    year: string | undefined,
    sitecode: string | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<QualityControlCalendarDTO> {
    let url_ = this.baseUrl + '/api/quality/my-control-calendar?';
    if (year === null) throw new Error("The parameter 'year' cannot be null.");
    else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
    if (sitecode === null) throw new Error("The parameter 'sitecode' cannot be null.");
    else if (sitecode !== undefined) url_ += 'sitecode=' + encodeURIComponent('' + sitecode) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processMyControlCalendar(_response);
      });
  }

  protected processMyControlCalendar(response: AxiosResponse): Promise<QualityControlCalendarDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = QualityControlCalendarDTO.fromJS(resultData200);
      return result200;
    } else if (status === 204) {
      const _responseText = response.data;
      return throwException('Customer not active', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('Customer not found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<QualityControlCalendarDTO>(<any>null);
  }

  /**
   * Get quality control list filtered by CustomerCode (Auth roles: Administrator,Pulinet)
   * @return Return quality control list filtered by customer
   */
  controlList(customercode: string, cancelToken?: CancelToken | undefined): Promise<QualityControlListItemDTO[]> {
    let url_ = this.baseUrl + '/api/quality/control-list/{customercode}';
    if (customercode === undefined || customercode === null)
      throw new Error("The parameter 'customercode' must be defined.");
    url_ = url_.replace('{customercode}', encodeURIComponent('' + customercode));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processControlList(_response);
      });
  }

  protected processControlList(response: AxiosResponse): Promise<QualityControlListItemDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(QualityControlListItemDTO.fromJS(item));
      }
      return result200;
    } else if (status === 204) {
      const _responseText = response.data;
      return throwException('Customer not active', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('Customer not found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<QualityControlListItemDTO[]>(<any>null);
  }

  /**
   * Request a new contradictory check for a site (Auth roles: Customer; policy: Customer_QualityControls)
   * @param body (optional)
   * @return Contradictory check was successfully added
   */
  contradictoryCheckPost(
    body: ContradictoryCheckDTO | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/api/quality/contradictory-check';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processContradictoryCheckPost(_response);
      });
  }

  protected processContradictoryCheckPost(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Invalid field values: some values are null or empty', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Update a contradictory check (Auth roles: Administrator,Pulinet)
   * @param body (optional)
   * @return Contradictory check was successfully updated
   */
  contradictoryCheckPut(body: ContradictoryCheckDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/quality/contradictory-check';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processContradictoryCheckPut(_response);
      });
  }

  protected processContradictoryCheckPut(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Invalid field values: some values are null or empty', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Get a contradictory check detail (Auth roles: Administrator,Pulinet)
   * @return Return contradictory check detail
   */
  contradictoryCheckGet(
    contradictorycheckid: number,
    cancelToken?: CancelToken | undefined
  ): Promise<ContradictoryCheckListItemDTO> {
    let url_ = this.baseUrl + '/api/quality/{contradictorycheckid}/contradictory-check';
    if (contradictorycheckid === undefined || contradictorycheckid === null)
      throw new Error("The parameter 'contradictorycheckid' must be defined.");
    url_ = url_.replace('{contradictorycheckid}', encodeURIComponent('' + contradictorycheckid));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processContradictoryCheckGet(_response);
      });
  }

  protected processContradictoryCheckGet(response: AxiosResponse): Promise<ContradictoryCheckListItemDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ContradictoryCheckListItemDTO.fromJS(resultData200);
      return result200;
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Invalid field values: some values are null or empty', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<ContradictoryCheckListItemDTO>(<any>null);
  }

  /**
   * Get contradictory request list filtered by CustomerCode (Auth roles: Administrator,Pulinet)
   * @param customercode (optional)
   * @return Return contradictory request list filtered by customer
   */
  contradictoryList(
    customercode: string | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<ContradictoryCheckListItemDTO[]> {
    let url_ = this.baseUrl + '/api/quality/contradictory-list?';
    if (customercode === null) throw new Error("The parameter 'customercode' cannot be null.");
    else if (customercode !== undefined) url_ += 'customercode=' + encodeURIComponent('' + customercode) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processContradictoryList(_response);
      });
  }

  protected processContradictoryList(response: AxiosResponse): Promise<ContradictoryCheckListItemDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ContradictoryCheckListItemDTO.fromJS(item));
      }
      return result200;
    } else if (status === 204) {
      const _responseText = response.data;
      return throwException('Customer not active', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('Customer not found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<ContradictoryCheckListItemDTO[]>(<any>null);
  }

  /**
   * Get contradictory request list for customer (Auth roles: Customer; policy: Customer_QualityControls)
   * @return Return contradictory request list for customer
   */
  myContradictoryList(cancelToken?: CancelToken | undefined): Promise<ContradictoryCheckListItemDTO[]> {
    let url_ = this.baseUrl + '/api/quality/my-contradictory-list';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processMyContradictoryList(_response);
      });
  }

  protected processMyContradictoryList(response: AxiosResponse): Promise<ContradictoryCheckListItemDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ContradictoryCheckListItemDTO.fromJS(item));
      }
      return result200;
    } else if (status === 204) {
      const _responseText = response.data;
      return throwException('Customer not active', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('Customer not found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<ContradictoryCheckListItemDTO[]>(<any>null);
  }
}

export class AuditReportListItemDTO implements IAuditReportListItemDTO {
  reportId?: number;
  name?: string | undefined;
  auditCode?: string | undefined;
  fileName?: string | undefined;
  readonly outcome?: boolean;
  outcomeString?: string | undefined;
  auditDate?: Date;
  contradictory?: boolean;
  siteId?: string | undefined;
  site?: SiteDetailsDTO;
  localType?: string | undefined;
  floor?: string | undefined;
  local?: string | undefined;
  auditor?: string | undefined;
  employeeId?: string | undefined;
  employee?: EmployeeListItemDTO;

  constructor(data?: IAuditReportListItemDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.reportId = _data['reportId'];
      this.name = _data['name'];
      this.auditCode = _data['auditCode'];
      this.fileName = _data['fileName'];
      (<any>this).outcome = _data['outcome'];
      this.outcomeString = _data['outcomeString'];
      this.auditDate = _data['auditDate'] ? new Date(_data['auditDate'].toString()) : <any>undefined;
      this.contradictory = _data['contradictory'];
      this.siteId = _data['siteId'];
      this.site = _data['site'] ? SiteDetailsDTO.fromJS(_data['site']) : <any>undefined;
      this.localType = _data['localType'];
      this.floor = _data['floor'];
      this.local = _data['local'];
      this.auditor = _data['auditor'];
      this.employeeId = _data['employeeId'];
      this.employee = _data['employee'] ? EmployeeListItemDTO.fromJS(_data['employee']) : <any>undefined;
    }
  }

  static fromJS(data: any): AuditReportListItemDTO {
    data = typeof data === 'object' ? data : {};
    let result = new AuditReportListItemDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['reportId'] = this.reportId;
    data['name'] = this.name;
    data['auditCode'] = this.auditCode;
    data['fileName'] = this.fileName;
    data['outcome'] = this.outcome;
    data['outcomeString'] = this.outcomeString;
    data['auditDate'] = this.auditDate ? this.auditDate.toISOString() : <any>undefined;
    data['contradictory'] = this.contradictory;
    data['siteId'] = this.siteId;
    data['site'] = this.site ? this.site.toJSON() : <any>undefined;
    data['localType'] = this.localType;
    data['floor'] = this.floor;
    data['local'] = this.local;
    data['auditor'] = this.auditor;
    data['employeeId'] = this.employeeId;
    data['employee'] = this.employee ? this.employee.toJSON() : <any>undefined;
    return data;
  }
}

export interface IAuditReportListItemDTO {
  reportId?: number;
  name?: string | undefined;
  auditCode?: string | undefined;
  fileName?: string | undefined;
  outcome?: boolean;
  outcomeString?: string | undefined;
  auditDate?: Date;
  contradictory?: boolean;
  siteId?: string | undefined;
  site?: SiteDetailsDTO;
  localType?: string | undefined;
  floor?: string | undefined;
  local?: string | undefined;
  auditor?: string | undefined;
  employeeId?: string | undefined;
  employee?: EmployeeListItemDTO;
}

export class AuditReportListItemDTOQueryResult implements IAuditReportListItemDTOQueryResult {
  data?: AuditReportListItemDTO[] | undefined;
  total?: number;

  constructor(data?: IAuditReportListItemDTOQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data']) this.data!.push(AuditReportListItemDTO.fromJS(item));
      }
      this.total = _data['total'];
    }
  }

  static fromJS(data: any): AuditReportListItemDTOQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new AuditReportListItemDTOQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['total'] = this.total;
    return data;
  }
}

export interface IAuditReportListItemDTOQueryResult {
  data?: AuditReportListItemDTO[] | undefined;
  total?: number;
}

export class ContradictoryCheckDTO implements IContradictoryCheckDTO {
  contradictoryCheckId?: number;
  text?: string | undefined;
  timestamp?: Date;
  controlDate?: Date | undefined;
  siteId?: string | undefined;
  creatorUserId?: string | undefined;

  constructor(data?: IContradictoryCheckDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contradictoryCheckId = _data['contradictoryCheckId'];
      this.text = _data['text'];
      this.timestamp = _data['timestamp'] ? new Date(_data['timestamp'].toString()) : <any>undefined;
      this.controlDate = _data['controlDate'] ? new Date(_data['controlDate'].toString()) : <any>undefined;
      this.siteId = _data['siteId'];
      this.creatorUserId = _data['creatorUserId'];
    }
  }

  static fromJS(data: any): ContradictoryCheckDTO {
    data = typeof data === 'object' ? data : {};
    let result = new ContradictoryCheckDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['contradictoryCheckId'] = this.contradictoryCheckId;
    data['text'] = this.text;
    data['timestamp'] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
    data['controlDate'] = this.controlDate ? this.controlDate.toISOString() : <any>undefined;
    data['siteId'] = this.siteId;
    data['creatorUserId'] = this.creatorUserId;
    return data;
  }
}

export interface IContradictoryCheckDTO {
  contradictoryCheckId?: number;
  text?: string | undefined;
  timestamp?: Date;
  controlDate?: Date | undefined;
  siteId?: string | undefined;
  creatorUserId?: string | undefined;
}

export class ContradictoryCheckListItemDTO implements IContradictoryCheckListItemDTO {
  contradictoryCheckId?: number;
  text?: string | undefined;
  timestamp?: Date;
  controlDate?: Date | undefined;
  siteId?: string | undefined;
  creatorUserId?: string | undefined;
  site?: SiteDetailsDTO;
  creator?: QualityUserListItemDTO;

  constructor(data?: IContradictoryCheckListItemDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contradictoryCheckId = _data['contradictoryCheckId'];
      this.text = _data['text'];
      this.timestamp = _data['timestamp'] ? new Date(_data['timestamp'].toString()) : <any>undefined;
      this.controlDate = _data['controlDate'] ? new Date(_data['controlDate'].toString()) : <any>undefined;
      this.siteId = _data['siteId'];
      this.creatorUserId = _data['creatorUserId'];
      this.site = _data['site'] ? SiteDetailsDTO.fromJS(_data['site']) : <any>undefined;
      this.creator = _data['creator'] ? QualityUserListItemDTO.fromJS(_data['creator']) : <any>undefined;
    }
  }

  static fromJS(data: any): ContradictoryCheckListItemDTO {
    data = typeof data === 'object' ? data : {};
    let result = new ContradictoryCheckListItemDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['contradictoryCheckId'] = this.contradictoryCheckId;
    data['text'] = this.text;
    data['timestamp'] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
    data['controlDate'] = this.controlDate ? this.controlDate.toISOString() : <any>undefined;
    data['siteId'] = this.siteId;
    data['creatorUserId'] = this.creatorUserId;
    data['site'] = this.site ? this.site.toJSON() : <any>undefined;
    data['creator'] = this.creator ? this.creator.toJSON() : <any>undefined;
    return data;
  }
}

export interface IContradictoryCheckListItemDTO {
  contradictoryCheckId?: number;
  text?: string | undefined;
  timestamp?: Date;
  controlDate?: Date | undefined;
  siteId?: string | undefined;
  creatorUserId?: string | undefined;
  site?: SiteDetailsDTO;
  creator?: QualityUserListItemDTO;
}

export class EmployeeListItemDTO implements IEmployeeListItemDTO {
  employeeId?: string | undefined;
  registrationNumber?: string | undefined;
  surname?: string | undefined;
  name?: string | undefined;
  birthDate?: string | undefined;
  fiscalCode?: string | undefined;
  image?: string | undefined;
  role?: string | undefined;
  hasComments?: boolean;
  hasRatings?: boolean;
  company?: string | undefined;

  constructor(data?: IEmployeeListItemDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.employeeId = _data['employeeId'];
      this.registrationNumber = _data['registrationNumber'];
      this.surname = _data['surname'];
      this.name = _data['name'];
      this.birthDate = _data['birthDate'];
      this.fiscalCode = _data['fiscalCode'];
      this.image = _data['image'];
      this.role = _data['role'];
      this.hasComments = _data['hasComments'];
      this.hasRatings = _data['hasRatings'];
      this.company = _data['company'];
    }
  }

  static fromJS(data: any): EmployeeListItemDTO {
    data = typeof data === 'object' ? data : {};
    let result = new EmployeeListItemDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['employeeId'] = this.employeeId;
    data['registrationNumber'] = this.registrationNumber;
    data['surname'] = this.surname;
    data['name'] = this.name;
    data['birthDate'] = this.birthDate;
    data['fiscalCode'] = this.fiscalCode;
    data['image'] = this.image;
    data['role'] = this.role;
    data['hasComments'] = this.hasComments;
    data['hasRatings'] = this.hasRatings;
    data['company'] = this.company;
    return data;
  }
}

export interface IEmployeeListItemDTO {
  employeeId?: string | undefined;
  registrationNumber?: string | undefined;
  surname?: string | undefined;
  name?: string | undefined;
  birthDate?: string | undefined;
  fiscalCode?: string | undefined;
  image?: string | undefined;
  role?: string | undefined;
  hasComments?: boolean;
  hasRatings?: boolean;
  company?: string | undefined;
}

export class FeeSplitDTO implements IFeeSplitDTO {
  endDate?: Date;
  items?: FeeSplitItemDTO[] | undefined;

  constructor(data?: IFeeSplitDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.endDate = _data['endDate'] ? new Date(_data['endDate'].toString()) : <any>undefined;
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(FeeSplitItemDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): FeeSplitDTO {
    data = typeof data === 'object' ? data : {};
    let result = new FeeSplitDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['endDate'] = this.endDate ? formatDate(this.endDate) : <any>undefined;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IFeeSplitDTO {
  endDate?: Date;
  items?: FeeSplitItemDTO[] | undefined;
}

export class FeeSplitItemDTO implements IFeeSplitItemDTO {
  startDate?: Date;
  notes?: string | undefined;
  fee?: number;

  constructor(data?: IFeeSplitItemDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.startDate = _data['startDate'] ? new Date(_data['startDate'].toString()) : <any>undefined;
      this.notes = _data['notes'];
      this.fee = _data['fee'];
    }
  }

  static fromJS(data: any): FeeSplitItemDTO {
    data = typeof data === 'object' ? data : {};
    let result = new FeeSplitItemDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['startDate'] = this.startDate ? formatDate(this.startDate) : <any>undefined;
    data['notes'] = this.notes;
    data['fee'] = this.fee;
    return data;
  }
}

export interface IFeeSplitItemDTO {
  startDate?: Date;
  notes?: string | undefined;
  fee?: number;
}

export class QualityControlCalendarDTO implements IQualityControlCalendarDTO {
  controls?: QualityControlCalendarListItemDTO[] | undefined;
  hasAnyControl?: boolean;

  constructor(data?: IQualityControlCalendarDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['controls'])) {
        this.controls = [] as any;
        for (let item of _data['controls']) this.controls!.push(QualityControlCalendarListItemDTO.fromJS(item));
      }
      this.hasAnyControl = _data['hasAnyControl'];
    }
  }

  static fromJS(data: any): QualityControlCalendarDTO {
    data = typeof data === 'object' ? data : {};
    let result = new QualityControlCalendarDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.controls)) {
      data['controls'] = [];
      for (let item of this.controls) data['controls'].push(item.toJSON());
    }
    data['hasAnyControl'] = this.hasAnyControl;
    return data;
  }
}

export interface IQualityControlCalendarDTO {
  controls?: QualityControlCalendarListItemDTO[] | undefined;
  hasAnyControl?: boolean;
}

export class QualityControlCalendarListItemDTO implements IQualityControlCalendarListItemDTO {
  site?: SiteDetailsDTO;
  qualityControlsMonths?: QualityControlMonthsDTO[] | undefined;

  constructor(data?: IQualityControlCalendarListItemDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.site = _data['site'] ? SiteDetailsDTO.fromJS(_data['site']) : <any>undefined;
      if (Array.isArray(_data['qualityControlsMonths'])) {
        this.qualityControlsMonths = [] as any;
        for (let item of _data['qualityControlsMonths'])
          this.qualityControlsMonths!.push(QualityControlMonthsDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): QualityControlCalendarListItemDTO {
    data = typeof data === 'object' ? data : {};
    let result = new QualityControlCalendarListItemDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['site'] = this.site ? this.site.toJSON() : <any>undefined;
    if (Array.isArray(this.qualityControlsMonths)) {
      data['qualityControlsMonths'] = [];
      for (let item of this.qualityControlsMonths) data['qualityControlsMonths'].push(item.toJSON());
    }
    return data;
  }
}

export interface IQualityControlCalendarListItemDTO {
  site?: SiteDetailsDTO;
  qualityControlsMonths?: QualityControlMonthsDTO[] | undefined;
}

export class QualityControlListItemDTO implements IQualityControlListItemDTO {
  controlId?: number;
  year?: string | undefined;
  month?: string | undefined;
  operativeArea?: string | undefined;
  controlManager?: string | undefined;
  siteId?: string | undefined;
  site?: SiteDetailsDTO;

  constructor(data?: IQualityControlListItemDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.controlId = _data['controlId'];
      this.year = _data['year'];
      this.month = _data['month'];
      this.operativeArea = _data['operativeArea'];
      this.controlManager = _data['controlManager'];
      this.siteId = _data['siteId'];
      this.site = _data['site'] ? SiteDetailsDTO.fromJS(_data['site']) : <any>undefined;
    }
  }

  static fromJS(data: any): QualityControlListItemDTO {
    data = typeof data === 'object' ? data : {};
    let result = new QualityControlListItemDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['controlId'] = this.controlId;
    data['year'] = this.year;
    data['month'] = this.month;
    data['operativeArea'] = this.operativeArea;
    data['controlManager'] = this.controlManager;
    data['siteId'] = this.siteId;
    data['site'] = this.site ? this.site.toJSON() : <any>undefined;
    return data;
  }
}

export interface IQualityControlListItemDTO {
  controlId?: number;
  year?: string | undefined;
  month?: string | undefined;
  operativeArea?: string | undefined;
  controlManager?: string | undefined;
  siteId?: string | undefined;
  site?: SiteDetailsDTO;
}

export class QualityControlMonthsDTO implements IQualityControlMonthsDTO {
  year?: string | undefined;
  month?: string | undefined;
  monthStrNum?: string | undefined;
  operativeArea?: string | undefined;
  controlManager?: string | undefined;

  constructor(data?: IQualityControlMonthsDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.year = _data['year'];
      this.month = _data['month'];
      this.monthStrNum = _data['monthStrNum'];
      this.operativeArea = _data['operativeArea'];
      this.controlManager = _data['controlManager'];
    }
  }

  static fromJS(data: any): QualityControlMonthsDTO {
    data = typeof data === 'object' ? data : {};
    let result = new QualityControlMonthsDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['year'] = this.year;
    data['month'] = this.month;
    data['monthStrNum'] = this.monthStrNum;
    data['operativeArea'] = this.operativeArea;
    data['controlManager'] = this.controlManager;
    return data;
  }
}

export interface IQualityControlMonthsDTO {
  year?: string | undefined;
  month?: string | undefined;
  monthStrNum?: string | undefined;
  operativeArea?: string | undefined;
  controlManager?: string | undefined;
}

export class QualityUserListItemDTO implements IQualityUserListItemDTO {
  name?: string | undefined;
  surname?: string | undefined;

  constructor(data?: IQualityUserListItemDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.surname = _data['surname'];
    }
  }

  static fromJS(data: any): QualityUserListItemDTO {
    data = typeof data === 'object' ? data : {};
    let result = new QualityUserListItemDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['surname'] = this.surname;
    return data;
  }
}

export interface IQualityUserListItemDTO {
  name?: string | undefined;
  surname?: string | undefined;
}

export class SiteDetailsDTO implements ISiteDetailsDTO {
  siteCode?: string | undefined;
  siteName?: string | undefined;
  jobTaskId?: string | undefined;
  jobTaskDescription?: string | undefined;
  address?: string | undefined;
  city?: string | undefined;
  lastServiceDay?: Date | undefined;
  startHour?: string | undefined;
  endHour?: string | undefined;
  operatingSegment?: string | undefined;
  cap?: string | undefined;
  province?: string | undefined;
  phone?: string | undefined;
  notes?: string | undefined;
  client?: string | undefined;
  image?: string | undefined;
  isOnDuty?: boolean;
  jobTaskDateFrom?: Date;
  jobTaskDateTo?: Date;
  dateFrom?: Date | undefined;
  dateTo?: Date | undefined;
  feeSplit?: FeeSplitDTO;
  siteServices?: SiteServiceDTO[] | undefined;
  jobTaskIsMarkedAsStarted?: boolean;

  constructor(data?: ISiteDetailsDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.siteCode = _data['siteCode'];
      this.siteName = _data['siteName'];
      this.jobTaskId = _data['jobTaskId'];
      this.jobTaskDescription = _data['jobTaskDescription'];
      this.address = _data['address'];
      this.city = _data['city'];
      this.lastServiceDay = _data['lastServiceDay'] ? new Date(_data['lastServiceDay'].toString()) : <any>undefined;
      this.startHour = _data['startHour'];
      this.endHour = _data['endHour'];
      this.operatingSegment = _data['operatingSegment'];
      this.cap = _data['cap'];
      this.province = _data['province'];
      this.phone = _data['phone'];
      this.notes = _data['notes'];
      this.client = _data['client'];
      this.image = _data['image'];
      this.isOnDuty = _data['isOnDuty'];
      this.jobTaskDateFrom = _data['jobTaskDateFrom'] ? new Date(_data['jobTaskDateFrom'].toString()) : <any>undefined;
      this.jobTaskDateTo = _data['jobTaskDateTo'] ? new Date(_data['jobTaskDateTo'].toString()) : <any>undefined;
      this.dateFrom = _data['dateFrom'] ? new Date(_data['dateFrom'].toString()) : <any>undefined;
      this.dateTo = _data['dateTo'] ? new Date(_data['dateTo'].toString()) : <any>undefined;
      this.feeSplit = _data['feeSplit'] ? FeeSplitDTO.fromJS(_data['feeSplit']) : <any>undefined;
      if (Array.isArray(_data['siteServices'])) {
        this.siteServices = [] as any;
        for (let item of _data['siteServices']) this.siteServices!.push(SiteServiceDTO.fromJS(item));
      }
      this.jobTaskIsMarkedAsStarted = _data['jobTaskIsMarkedAsStarted'];
    }
  }

  static fromJS(data: any): SiteDetailsDTO {
    data = typeof data === 'object' ? data : {};
    let result = new SiteDetailsDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['siteCode'] = this.siteCode;
    data['siteName'] = this.siteName;
    data['jobTaskId'] = this.jobTaskId;
    data['jobTaskDescription'] = this.jobTaskDescription;
    data['address'] = this.address;
    data['city'] = this.city;
    data['lastServiceDay'] = this.lastServiceDay ? this.lastServiceDay.toISOString() : <any>undefined;
    data['startHour'] = this.startHour;
    data['endHour'] = this.endHour;
    data['operatingSegment'] = this.operatingSegment;
    data['cap'] = this.cap;
    data['province'] = this.province;
    data['phone'] = this.phone;
    data['notes'] = this.notes;
    data['client'] = this.client;
    data['image'] = this.image;
    data['isOnDuty'] = this.isOnDuty;
    data['jobTaskDateFrom'] = this.jobTaskDateFrom ? formatDate(this.jobTaskDateFrom) : <any>undefined;
    data['jobTaskDateTo'] = this.jobTaskDateTo ? formatDate(this.jobTaskDateTo) : <any>undefined;
    data['dateFrom'] = this.dateFrom ? formatDate(this.dateFrom) : <any>undefined;
    data['dateTo'] = this.dateTo ? formatDate(this.dateTo) : <any>undefined;
    data['feeSplit'] = this.feeSplit ? this.feeSplit.toJSON() : <any>undefined;
    if (Array.isArray(this.siteServices)) {
      data['siteServices'] = [];
      for (let item of this.siteServices) data['siteServices'].push(item.toJSON());
    }
    data['jobTaskIsMarkedAsStarted'] = this.jobTaskIsMarkedAsStarted;
    return data;
  }
}

export interface ISiteDetailsDTO {
  siteCode?: string | undefined;
  siteName?: string | undefined;
  jobTaskId?: string | undefined;
  jobTaskDescription?: string | undefined;
  address?: string | undefined;
  city?: string | undefined;
  lastServiceDay?: Date | undefined;
  startHour?: string | undefined;
  endHour?: string | undefined;
  operatingSegment?: string | undefined;
  cap?: string | undefined;
  province?: string | undefined;
  phone?: string | undefined;
  notes?: string | undefined;
  client?: string | undefined;
  image?: string | undefined;
  isOnDuty?: boolean;
  jobTaskDateFrom?: Date;
  jobTaskDateTo?: Date;
  dateFrom?: Date | undefined;
  dateTo?: Date | undefined;
  feeSplit?: FeeSplitDTO;
  siteServices?: SiteServiceDTO[] | undefined;
  jobTaskIsMarkedAsStarted?: boolean;
}

export class SiteServiceDTO implements ISiteServiceDTO {
  siteServiceId?: number;
  serviceName?: string | undefined;
  from?: Date | undefined;
  to?: Date | undefined;

  constructor(data?: ISiteServiceDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.siteServiceId = _data['siteServiceId'];
      this.serviceName = _data['serviceName'];
      this.from = _data['from'] ? new Date(_data['from'].toString()) : <any>undefined;
      this.to = _data['to'] ? new Date(_data['to'].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): SiteServiceDTO {
    data = typeof data === 'object' ? data : {};
    let result = new SiteServiceDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['siteServiceId'] = this.siteServiceId;
    data['serviceName'] = this.serviceName;
    data['from'] = this.from ? formatDate(this.from) : <any>undefined;
    data['to'] = this.to ? formatDate(this.to) : <any>undefined;
    return data;
  }
}

export interface ISiteServiceDTO {
  siteServiceId?: number;
  serviceName?: string | undefined;
  from?: Date | undefined;
  to?: Date | undefined;
}

function formatDate(d: Date) {
  return (
    d.getFullYear() +
    '-' +
    (d.getMonth() < 9 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) +
    '-' +
    (d.getDate() < 10 ? '0' + d.getDate() : d.getDate())
  );
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}
